import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("label", {
    for: _ctx.labelId,
    class: [{ 'text-gray-600': !_ctx.error, 'text-red-600': _ctx.error }, "text-sm"]
  }, _toDisplayString(_ctx.label), 11, ["for"]))
}